/* tslint:disable */
/* eslint-disable */
/**
 * Jen API
 * Jen RESTful APIs, designed to provide easy access to our latest music generation models.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EditMusicParamsDto } from './EditMusicParamsDto';
import {
    EditMusicParamsDtoFromJSON,
    EditMusicParamsDtoFromJSONTyped,
    EditMusicParamsDtoToJSON,
    EditMusicParamsDtoToJSONTyped,
} from './EditMusicParamsDto';

/**
 * 
 * @export
 * @interface EditMusicEffectsDto
 */
export interface EditMusicEffectsDto {
    /**
     * 
     * @type {string}
     * @memberof EditMusicEffectsDto
     */
    type: string;
    /**
     * 
     * @type {EditMusicParamsDto}
     * @memberof EditMusicEffectsDto
     */
    params: EditMusicParamsDto;
}

/**
 * Check if a given object implements the EditMusicEffectsDto interface.
 */
export function instanceOfEditMusicEffectsDto(value: object): value is EditMusicEffectsDto {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('params' in value) || value['params'] === undefined) return false;
    return true;
}

export function EditMusicEffectsDtoFromJSON(json: any): EditMusicEffectsDto {
    return EditMusicEffectsDtoFromJSONTyped(json, false);
}

export function EditMusicEffectsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EditMusicEffectsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'params': EditMusicParamsDtoFromJSON(json['params']),
    };
}

export function EditMusicEffectsDtoToJSON(json: any): EditMusicEffectsDto {
    return EditMusicEffectsDtoToJSONTyped(json, false);
}

export function EditMusicEffectsDtoToJSONTyped(value?: EditMusicEffectsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'params': EditMusicParamsDtoToJSON(value['params']),
    };
}

